"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlashList = void 0;
var RecyclerView_1 = require("./recyclerview/RecyclerView");
Object.defineProperty(exports, "FlashList", { enumerable: true, get: function () { return RecyclerView_1.RecyclerView; } });
//# sourceMappingURL=FlashList.js.map